// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UpdateInfoForm_container__1\\+956 {
  max-width: 620px;
  padding: var(--space-6);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--bg);
  box-shadow: var(--shadow-xs);
  box-sizing: border-box;
}

.UpdateInfoForm_title__8aEPv {
  margin: 0 0 var(--space-5);
  font-size: 1.0625rem;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: -0.008em;
  color: var(--text-primary);
}

.UpdateInfoForm_form__jv5bv {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.UpdateInfoForm_row__qEQa4 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-3);
}

/* City grows; state and zip stay narrow. */
.UpdateInfoForm_row__qEQa4:nth-of-type(2) {
  grid-template-columns: 2fr 1fr 1.2fr;
}

.UpdateInfoForm_field__RevH5,
.UpdateInfoForm_fieldSmall__aWl4Z {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}

.UpdateInfoForm_label__yvIHo {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.45;
  color: var(--text-primary);
}

.UpdateInfoForm_input__p1rI\\+ {
  width: 100%;
  min-height: 40px;
  padding: 9px 12px;
  border: 1px solid var(--border-dark);
  border-radius: var(--radius-input);
  background: var(--bg);
  color: var(--text-primary);
  font-family: var(--font);
  font-size: 0.9375rem;
  line-height: 1.45;
  box-sizing: border-box;
  transition:
    border-color var(--dur-fast) var(--ease-standard),
    box-shadow var(--dur-fast) var(--ease-standard);
}

.UpdateInfoForm_input__p1rI\\+::placeholder {
  color: var(--text-placeholder);
}

.UpdateInfoForm_input__p1rI\\+:focus,
.UpdateInfoForm_input__p1rI\\+:focus-visible {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(157, 31, 95, 0.12);
}

.UpdateInfoForm_button__Aljh9 {
  align-self: flex-start;
  min-height: 40px;
  padding: 9px 18px;
  border: 1px solid transparent;
  border-radius: var(--radius-input);
  background: var(--primary);
  color: var(--text-on-primary);
  font-family: var(--font);
  font-size: 0.9375rem;
  font-weight: 700;
  line-height: 1.4;
  cursor: pointer;
  transition: background-color var(--dur-fast) var(--ease-standard);
}

.UpdateInfoForm_button__Aljh9:not(:disabled):hover {
  background: var(--primary-light);
}

.UpdateInfoForm_button__Aljh9:not(:disabled):active {
  transform: translateY(1px);
}

.UpdateInfoForm_button__Aljh9:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.UpdateInfoForm_messageError__IY\\+bP,
.UpdateInfoForm_messageSuccess__Wbiby {
  margin: 0;
  padding: 9px 12px;
  border-radius: var(--radius-sm);
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.45;
}

.UpdateInfoForm_messageError__IY\\+bP {
  background: var(--surface-error);
  color: #b71c1c;
}

.UpdateInfoForm_messageSuccess__Wbiby {
  background: var(--surface-success);
  color: #1b5e20;
}

@media (max-width: 640px) {
  .UpdateInfoForm_container__1\\+956 {
    padding: var(--space-5);
  }

  .UpdateInfoForm_row__qEQa4,
  .UpdateInfoForm_row__qEQa4:nth-of-type(2) {
    grid-template-columns: minmax(0, 1fr);
  }

  .UpdateInfoForm_button__Aljh9 {
    align-self: stretch;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Profile/Info/UpdateInfoForm.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,qBAAqB;EACrB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,oCAAoC;AACtC;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,kCAAkC;EAClC,qBAAqB;EACrB,0BAA0B;EAC1B,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB;;mDAEiD;AACnD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kCAAkC;EAClC,0BAA0B;EAC1B,6BAA6B;EAC7B,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iEAAiE;AACnE;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;;IAEE,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".container {\n  max-width: 620px;\n  padding: var(--space-6);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  background: var(--bg);\n  box-shadow: var(--shadow-xs);\n  box-sizing: border-box;\n}\n\n.title {\n  margin: 0 0 var(--space-5);\n  font-size: 1.0625rem;\n  font-weight: 700;\n  line-height: 1.4;\n  letter-spacing: -0.008em;\n  color: var(--text-primary);\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-5);\n}\n\n.row {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--space-3);\n}\n\n/* City grows; state and zip stay narrow. */\n.row:nth-of-type(2) {\n  grid-template-columns: 2fr 1fr 1.2fr;\n}\n\n.field,\n.fieldSmall {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 0;\n}\n\n.label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.45;\n  color: var(--text-primary);\n}\n\n.input {\n  width: 100%;\n  min-height: 40px;\n  padding: 9px 12px;\n  border: 1px solid var(--border-dark);\n  border-radius: var(--radius-input);\n  background: var(--bg);\n  color: var(--text-primary);\n  font-family: var(--font);\n  font-size: 0.9375rem;\n  line-height: 1.45;\n  box-sizing: border-box;\n  transition:\n    border-color var(--dur-fast) var(--ease-standard),\n    box-shadow var(--dur-fast) var(--ease-standard);\n}\n\n.input::placeholder {\n  color: var(--text-placeholder);\n}\n\n.input:focus,\n.input:focus-visible {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(157, 31, 95, 0.12);\n}\n\n.button {\n  align-self: flex-start;\n  min-height: 40px;\n  padding: 9px 18px;\n  border: 1px solid transparent;\n  border-radius: var(--radius-input);\n  background: var(--primary);\n  color: var(--text-on-primary);\n  font-family: var(--font);\n  font-size: 0.9375rem;\n  font-weight: 700;\n  line-height: 1.4;\n  cursor: pointer;\n  transition: background-color var(--dur-fast) var(--ease-standard);\n}\n\n.button:not(:disabled):hover {\n  background: var(--primary-light);\n}\n\n.button:not(:disabled):active {\n  transform: translateY(1px);\n}\n\n.button:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.messageError,\n.messageSuccess {\n  margin: 0;\n  padding: 9px 12px;\n  border-radius: var(--radius-sm);\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.45;\n}\n\n.messageError {\n  background: var(--surface-error);\n  color: #b71c1c;\n}\n\n.messageSuccess {\n  background: var(--surface-success);\n  color: #1b5e20;\n}\n\n@media (max-width: 640px) {\n  .container {\n    padding: var(--space-5);\n  }\n\n  .row,\n  .row:nth-of-type(2) {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .button {\n    align-self: stretch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UpdateInfoForm_container__1+956`,
	"title": `UpdateInfoForm_title__8aEPv`,
	"form": `UpdateInfoForm_form__jv5bv`,
	"row": `UpdateInfoForm_row__qEQa4`,
	"field": `UpdateInfoForm_field__RevH5`,
	"fieldSmall": `UpdateInfoForm_fieldSmall__aWl4Z`,
	"label": `UpdateInfoForm_label__yvIHo`,
	"input": `UpdateInfoForm_input__p1rI+`,
	"button": `UpdateInfoForm_button__Aljh9`,
	"messageError": `UpdateInfoForm_messageError__IY+bP`,
	"messageSuccess": `UpdateInfoForm_messageSuccess__Wbiby`
};
export default ___CSS_LOADER_EXPORT___;
